import { Component, OnInit } from "@angular/core";
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
} from "@angular/router";

import { filter, map, tap } from "rxjs/operators";
import { ProfileViewModel } from "./data/api/models/profile-view-model";
import { BackButtonStateService } from "./core/services/back-button-state.service";
import { ContainerComponent } from "./layout/container/container.component";
import {environment} from "../environments/environment";
import {ApiConfiguration} from "./data/szzAiApi/api-configuration";

@Component({
  selector: "szz-app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [
    ContainerComponent
],
})
export class AppComponent implements OnInit {
  title = "ai-assistant";
  idleState = "Not started.";
  isAuthenticated: boolean = false;
  profileModel: ProfileViewModel = {};

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly backButtonStateService: BackButtonStateService,
    private apiConfig: ApiConfiguration,
  ) {
    this.apiConfig.rootUrl = environment.aiApiRootUrl;
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (child?.snapshot?.data["showBack"]) {
              return child.snapshot.data["showBack"];
            } else {
              return null;
            }
          }
          return null;
        }),
        tap((x) => {
          this.backButtonStateService.updateButtonState(x || false);
        })
      )
      .subscribe();
  }
}
